import { RichText } from "components/RichTextWidget";
import { useTranslation } from "features/translations";
import { buildWidgetInstanceId } from "features/widgets";
import { useMemo } from "react";
import { Container, Heading3, Heading5 } from "shared/components";
import { useCollectedData } from "shared/contexts/PageData";

import styles from "./Content079.module.scss";
import { Item } from "./Item";

export const Content079 = ({ payload }) => {
  const instanceId = buildWidgetInstanceId("079", payload.id);
  const { t } = useTranslation();
  const { events } = useCollectedData(instanceId, [
    { name: "events", defaultValue: [] },
  ]);

  const title = payload?.title ?? "";
  const description = payload?.caption ?? "";

  const slicedItems = useMemo(() => {
    return events.slice(0, 4);
  }, [events]);

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.blocks}>
          <div className={styles.top}>
            <Heading3 as="h3" className={styles.title}>
              {title}
            </Heading3>
            <RichText
              value={description}
              className={styles.description}
              color="dark"
            />
          </div>
          {events.length > 0 ? (
            <div className={styles.items}>
              {slicedItems.map((item) => (
                <Item item={item} key={item.id} />
              ))}
            </div>
          ) : (
            <Heading5 appearance="bold">{t("empty_events")}</Heading5>
          )}
        </div>
      </Container>
    </div>
  );
};

export default Content079;
